import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "प्रतिक्रिया", link: "#" },
    { name: "नियम एवं शर्तें", link: "#" },
    { name: "बेबसाइट नीति", link: "#" },
    { name: "साइटमैप", link: "#" },
    { name: "एल्यूमिनाई रजिस्ट्रेशन", link: "#" },
    { name: "सामान्य प्रश्न", link: "#" },
];

export default function Miscellaneous() {
    const [showSidebar, setShowSidebar] = useState(true);
    // ➜ पहला item automatically active करने के लिए
    const [content, setContent] = useState(departments[0].name);  // पहले का name
    const [selectedIndex, setSelectedIdx] = useState(0);         // 0 index (पहला)

    const handleItemClick = (deptName, idx) => {
        setContent(deptName);
        setSelectedIdx(idx);
        setShowSidebar(false);
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            {/* Toggle Button */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`text-white p-3 shadow-lg d-flex flex-column
                    ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">विविध</h5>

                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            onClick={() => handleItemClick(dept.name, index)}
                            className="mb-1 p-2 rounded small shadow-sm"
                            style={{
                                cursor: "pointer",
                                backgroundColor: selectedIndex === index ? "#77236b" : "white",
                                color: selectedIndex === index ? "white" : "black"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9"
                onClick={() => setShowSidebar(false)}
            >
                <p>{content}</p>
            </main>
        </div>
    );
}
